import React, { useEffect, useState } from 'react';
import Newbanner from './Newbanner';
import Landiningnavbar from './landiningnavbar'; // Fixed capitalization
import Scrennpopup from '../Scrennpopup'
import Programoffer from '../Programoffer';
import StatsSection from './StatsSection'
import Stack from '../Stack'
import Landiningfotter from './Landiningfotter'

const WhoweAre = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
        
  return (
    <div style={{backgroundColor: "white"}}>
      <Landiningnavbar /> {/* Fixed component name to start with capital letter */}
      <Newbanner />
       <Scrennpopup />
               <Programoffer/>
               <StatsSection/>
                 <Stack/>
                 <Landiningfotter />
    </div>
  );
}

export default WhoweAre;